import axios from 'axios';
import Jio_Saavan_sonstant from './Jio_Saavan_sonstant';
import apiLogger from '../apiLogger';

export const Jio_Saavan_axios_adapter = axios.create({
    baseURL: Jio_Saavan_sonstant.JIO_SAAVAN_BASE_URL,
    timeout: 60 * 1000,
    headers: {
        'Content-Type': 'application/json',
    },
});

Jio_Saavan_axios_adapter.interceptors.request.use(
    async (config) => {
        if (config.baseURL === Jio_Saavan_sonstant.JIO_SAAVAN_BASE_URL) {
            
        } 
        return apiLogger.request(config);
    },
    (error) => apiLogger.error(error)
);

Jio_Saavan_axios_adapter.interceptors.response.use(
    (response) => apiLogger.response(response),
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401) {

        }

        return apiLogger.error(error);
    }
);
